/**
 * @voltxampere/ui — ATtiny85 variant (Sprint 47-1)
 *
 * Sprint 43-5 placeholder (digital-gate) → Sprint 47-1 mcu-execution
 * canonical engine type migration. Per-family defaults Sprint 46
 * component definition'da `family: "attiny85"`'tan resolve edilir
 * (8 KB flash, 512 B SRAM, 6 GPIO, 4 ADC, 4 PWM).
 *
 * Reference: Microchip ATtiny85V-10PU, DIP-8. AVR-8bit family.
 * Vcc 1.8-5.5 V, fmax 10/20 MHz, 8 KB Flash / 512 B SRAM / 512 B EEPROM,
 * 6 GPIO, 4-channel 10-bit ADC, 4 PWM, USI (SPI/I2C), no UART.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const mcuAttiny85 = {
    id: "attiny85",
    nameTr: "ATtiny85 (DIP-8)",
    nameEn: "ATtiny85 (DIP-8)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "ATtiny85",
    schemaType: "mcu-execution",
    defaultParams: {
        family: "attiny85",
        clockHz: 8e6,
        flashHex: "",
        instructionsPerTick: 1000,
        vSupply: 5,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=mcu-attiny85.js.map